import { AutogenModelMiscBillHist, AutogenRowMiscBillHist } from "./autogen/AutogenModelMiscBillHist";

export class ModelMiscBillHist extends AutogenModelMiscBillHist<RowMiscBillHist> {
	constructor() {
		super(RowMiscBillHist);
	}
}

export class RowMiscBillHist extends AutogenRowMiscBillHist {
}
